import { useContext } from 'react';
import { AssessmentsContext, AssessmentsContextValue } from '../contexts/AssessmentsContext';

export const useAssessmentsContext = (): AssessmentsContextValue => {
  const context = useContext(AssessmentsContext);
  if (!context) {
    throw new Error('useAssessmentsContext must be used within an AssessmentsProvider');
  }
  return context;
};
